import gql from 'graphql-tag';

// How many parties on one payer side are opted out of EVERY resolving master.
//
// Fall-through means adding a master changes what existing opt-out rows do: a
// party opted out of all of today's masters drops to the new one and starts being
// charged again, with nobody editing their rows. This count puts that on the
// create form so it is a decision rather than a discovery.
//
// Counted server-side because the client cannot do it correctly — grouping
// opt-outs by party needs every row, and the list endpoint caps at 200.
const defaultCoverageFullyOptedOutCountQuery = gql`
  query GetDefaultCoverageFullyOptedOutCount($masterType: String!) {
    defaultCoverageFullyOptedOutCount(masterType: $masterType)
  }
`;

export default defaultCoverageFullyOptedOutCountQuery;
